











































































































import mixins from 'vue-typed-mixins'
import DraftElement from '@/calendesk/sections/section/mixins/DraftElement'
import SelectableEmployee from '@/calendesk/models/SelectableEmployee'
import Employee from '@/calendesk/models/DTO/Response/Employee'
import VCardWrapper from '@/calendesk/sections/section/calendars/calendarV2/components/VCardWrapper.vue'

export default mixins(DraftElement).extend({
  components: { VCardWrapper },
  props: {
    selectableEmployee: {
      type: SelectableEmployee,
      required: true
    },
    textColor: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: null
    },
    changeMode: {
      type: Boolean,
      default: false
    },
    disableChanging: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    classForViewRound: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      truncateDescription: true
    }
  },
  computed: {
    getEmployeesToDisplay (): Employee[] {
      return this.selectableEmployee.employees.slice(0, this.$vuetify.breakpoint.mdAndUp ? 5 : 3)
    },
    socialMedia (): Record<string, any>[] {
      // Create an array with all possible social media entries
      const allEntries = [
        {
          icon: '$facebook',
          link: this.selectableEmployee.getFacebookUrl(),
          extraClass: 'social-icon-scale'
        },
        {
          icon: '$instagram',
          link: this.selectableEmployee.getInstagramUrl(),
          extraClass: 'social-icon-scale'
        },
        {
          icon: '$youtube',
          link: this.selectableEmployee.getYoutubeUrl(),
          extraClass: 'social-icon-scale'
        },
        {
          icon: '$tiktok',
          link: this.selectableEmployee.getTiktokUrl(),
          extraClass: 'social-icon-scale'
        },
        {
          icon: '$x',
          link: this.selectableEmployee.getTwitterUrl(),
          extraClass: 'social-icon-scale'
        },
        {
          icon: '$linkedin',
          link: this.selectableEmployee.getLinkedInUrl(),
          extraClass: ''
        }
      ]

      // Filter the array to include only those entries where the link exists
      return allEntries.filter(entry => entry.link)
    },
    getTruncatedEmployeeDescription (): string {
      if (!this.selectableEmployee.getDescription()) return ''
      return (this.$options.filters as any).truncateHtml(this.selectableEmployee.getDescription(), (this.changeMode ? 180 : 280))
    }
  },
  methods: {
    update () {
      this.$emit('change', this.changeMode ? null : this.selectableEmployee)
    }
  }
})
